/**
 * grafoDoRepo — o que a etapa Git diz sobre o GRAFO de código de um repositório.
 *
 * O worker grava o estado do grafo a cada indexação (status.json no volume /graphs) e
 * a API o devolve em GET /projects/{id}/git-repositories/graph-status. Antes a falha do
 * grafo era muda: o repositório aparecia "Indexado" e a execução brownfield rodava sem
 * o grafo. Aqui o estado vira texto — pronto, falhou (com o motivo), em construção ou
 * ainda não gerado.
 *
 * Funções puras (sem React): a tela só escolhe a cor.
 */

/** Commit curto (7 caracteres), como o git mostra. */
export function commitCurto(commit) {
  return String(commit ?? '').trim().slice(0, 7);
}

/**
 * Rótulo do grafo de um repositório.
 * @param {object|null|undefined} grafo — item de `repos[repoId]` do graph-status
 * @returns {{ texto: string, tom: 'ok'|'erro'|'neutro' } | null} null = nada a dizer
 */
export function rotuloDoGrafo(grafo) {
  if (!grafo) return null;
  if (grafo.ok) {
    const nos = Number(grafo.nos ?? 0).toLocaleString('pt-BR');
    const commit = commitCurto(grafo.commit);
    return {
      texto: `Grafo: pronto (${nos} nós${commit ? `, commit ${commit}` : ''})`,
      tom: 'ok',
    };
  }
  if (grafo.estado === 'construindo') {
    return { texto: 'Grafo: em construção…', tom: 'neutro' };
  }
  if (grafo.estado === 'ausente') {
    return { texto: 'Grafo: ainda não gerado — indexe o repositório', tom: 'neutro' };
  }
  const motivo = String(grafo.motivo ?? '').trim() || 'motivo não registrado';
  return { texto: `Grafo: falhou — ${motivo}`, tom: 'erro' };
}

/**
 * Aviso de que a branch cadastrada não existia e a indexação usou a default do
 * repositório (o cadastro já foi atualizado pelo worker).
 * @returns {string|null}
 */
export function avisoDeBranch(grafo) {
  if (!grafo || grafo.branch_origem !== 'default') return null;
  const cadastrada = String(grafo.branch_cadastrada ?? '').trim();
  const usada = String(grafo.branch ?? '').trim();
  if (!cadastrada || !usada || cadastrada === usada) return null;
  return `a branch cadastrada \`${cadastrada}\` não existe; usando a default \`${usada}\``;
}

/** A indexação foi feita da branch da ENTREGA (pedido explícito), não da cadastrada. */
export function avisoDeEntrega(grafo) {
  if (!grafo || grafo.branch_origem !== 'entrega') return null;
  const usada = String(grafo.branch ?? '').trim();
  if (!usada) return null;
  return `índice feito da branch da entrega \`${usada}\` — reindexe para voltar à cadastrada`;
}
